import GroupControls from "./GroupControls"
import classes from './Group.module.css'
import GroupItemSearch from "./GroupItemSearch"
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions"
import IconBox from "../../../iconboxes/IconBox"

const NoDataInput = ({folder, groupData, fieldsData, label, apiCase}) => {
    let userPermissionDisabled = useUserTabEditPermissionDisabled(apiCase)
    return <div className="relative">
        <div className={classes.no_data_input}>
            <GroupItemSearch label={label} activeCaseData={null} data={groupData} fieldsData={fieldsData} folder={folder} apiCase={apiCase}/>
            {!userPermissionDisabled && <GroupControls folder={folder} groupData={groupData} groupDataID={groupData.id} fieldsData={fieldsData} apiCase={apiCase}/>}

            {folder == 'liabilities' && <>
                <div className={classes.contact_information_group}>
                    {groupData.adjuster_phone_legacy && <IconBox type={'phone'} link={groupData.adjuster_phone_legacy} ext={groupData.adjuster_phone_ext_legacy}>
                        <i className="ti ti-phone"></i>
                    </IconBox>}
                    {/* {activeCaseData.contact_information?.cell_phone && <IconBox type={'phone'} link={activeCaseData.contact_information?.cell_phone}>
                        <i className="ti ti-device-mobile"></i>
                    </IconBox>}
                    {activeCaseData.contact_information?.cell_phone && <IconBox type={'sms'} link={activeCaseData.contact_information?.cell_phone} smsMail={smsMail} fullInformation={data}>
                        <i className="ti ti-device-mobile-message"></i>
                    </IconBox>} */}

                    {groupData.adjuster_fax_legacy && <IconBox type={'fax'} link={groupData.adjuster_fax_legacy} fullInformation={groupData}>
                        <i className="ti ti-printer"></i>
                    </IconBox>}

                    {groupData.adjuster_email_legacy && <IconBox type={'mail'} link={groupData.adjuster_email_legacy} smsMail={'Adjuster'} fullInformation={groupData}>
                        <i className="ti ti-mail"></i>
                    </IconBox>}
                    
                </div> 
            </>}
        </div>
    </div>
}

export default NoDataInput